module.exports = __webpack_public_path__ + "img/titleen.aed766fb.png";